// extracted by mini-css-extract-plugin
export default {"card":"Card_card__FYQMH","image":"Card_image__azDKs","special":"Card_special__1rtbF","name":"Card_name__xnnft"};